import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Input, DatePicker } from "antd";
import Menubar from "../../../../components/WhrManager/App";
import { useSelector } from "react-redux";
import { http } from "../../../../services/http";
import RowDataModal from "../../../../components/row-data";
import CreateProductModal from "../../../../components/WhrManager/createProductModal";
import { SearchOutlined } from "@ant-design/icons";
import debounce from "lodash.debounce";
import Highlighter from "react-highlight-words";
import { useTranslation } from "react-i18next";
import Header from "../../../../components/header";
import { column } from "../../../../utils/columns";
import { aggregateDocuments } from "../../../../utils/document";
import moment from "moment";
import { get } from "lodash";

const { RangePicker } = DatePicker;

const MySales = () => {
  const employeId = useSelector((state) => state.main.employeeId);
  const { t } = useTranslation();

  const today = new Date();
  const day = ("0" + today.getDate()).slice(-2);
  const month = ("0" + (today.getMonth() + 1)).slice(-2);
  const year = today.getFullYear();
  const formattedDate = `${year}-${month}-${day}`;

  const [fdata, setFData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isCreateProductModalVisible, setIsCreateProductModalVisible] =
    useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [docNum, setDocNum] = useState("");
  const [cardName, setCardName] = useState("");
  const [slpName, setSlpName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(formattedDate);
  const [total, setTotal] = useState(0);
  let searchInput = null;

  const handleSearch = (e, confirm, dataIndex) => {
    const value = e.target.value;
    debouncedSearch(value, dataIndex, confirm);
  };

  const getColumnSearchProps = (dataIndex) => {
    if (dataIndex === "sana") {
      return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <RangePicker
              value={selectedKeys ? selectedKeys[0] : []}
              onChange={(dates) => {
                setSelectedKeys(dates ? dates : []);
                handleDateRangeChange(dates, confirm, dataIndex);
              }}
              style={{ marginBottom: 8, display: "block" }}
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
            />
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
          if (Array.isArray(value) && value.length === 2) {
            const [startDate, endDate] = value;
            if (startDate && endDate) {
              const recordDate = moment(record[dataIndex]);
              return recordDate.isBetween(startDate, endDate, "[]");
            }
          }

          return true;
        },
        render: (text) => text,
      };
    }
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              searchInput = node;
            }}
            placeholder={`${t("search")} ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              handleSearch(e, confirm, dataIndex);
            }}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.select(), 100);
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  };

  const columns = column(t, getColumnSearchProps).map((col) => {
    if (col.dataIndex === "summa") {
      return {
        ...col,
        render: (text, record) => {
          const formatSum =
            record.docCur === "UZS"
              ? new Intl.NumberFormat("fr-FR").format(record.docTotalFC)
              : new Intl.NumberFormat("fr-FR").format(text);
          return `${formatSum} ${record.docCur}`;
        },
      };
    }

    if (col.dataIndex === "docNum") {
      return {
        ...col,
        title: t("numSale"),
      };
    }

    return col;
  });

  const orderTypeColumn = {
    title: "Kim tomonidan yaratildi",
    dataIndex: "u_OrderType",
    key: "u_OrderType",
    render: (text) => {
      const orderTypeConfig = {
        bysap: {
          label: "SAP orqali yaratildi",
          background: "#E3F2FD",
          color: "#0B5394",
        },
        bycustomer: {
          label: "Mijoz tomonidan yaratildi",
          background: "#E8F5E9",
          color: "#1B5E20",
        },
        bywhsmanager: {
          label: "Omborchi tomonidan yaratildi",
          background: "#FFF3E0",
          color: "#BF360C",
        },
      };

      const normalizedKey = (text || "").trim().toLowerCase();
      const config = orderTypeConfig[normalizedKey] || {
        label: text || "-",
        background: "#F3F4F6",
        color: "#1F2937",
      };

      return (
        <span
          style={{
            display: "inline-block",
            padding: "4px 10px",
            borderRadius: "9999px",
            backgroundColor: config.background,
            color: config.color,
            fontWeight: 500,
            fontSize: "12px",
          }}
        >
          {config.label}
        </span>
      );
    },
  };

  columns.push(orderTypeColumn);

  const fetchData = useCallback(
    async (page, ScardName, SdocNum, SslpName, SstartDate, SendDate) => {
      try {
        let url = " ";
        setLoading(true);

        url = `api/meningsotuvlarim?cardName=${ScardName}&docNum=${SdocNum}&slpName=${SslpName}&ownerCode=${employeId}&startDate=${SstartDate}&endDate=${SendDate}&pageToken=${page}`;

        const { data } = await http.get(url);

        const formattedData = aggregateDocuments(data);
        console.log(formattedData);

        const hasMore = formattedData.length === 10 ? true : false;
        setFData(formattedData);
        setHasMoreData(hasMore);
        setTotal(get(data, "total", 0));
        console.log(get(data, "total", 0));
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    },
    [employeId, cardName, docNum, startDate, endDate, slpName],
  );
  const handleDateRangeChange = (dates, confirm, dataIndex) => {
    debouncedSearch(dates, dataIndex, confirm);
  };

  const handleStartDate = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDate = (e) => {
    setEndDate(e.target.value);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value, dataIndex, confirm) => {
        if (dataIndex === "mijoz") {
          if (value) {
            setCardName(value);
          } else {
            setCardName("");
          }
        } else if (dataIndex === "docNum") {
          if (value) {
            setDocNum(value);
          } else {
            setDocNum("");
          }
        } else if (dataIndex === "yaratdi") {
          if (value) {
            setSlpName(value.toUpperCase());
          } else {
            setSlpName("");
          }
        } else if (dataIndex === "sana") {
          if (value) {
            const formattedStartDate = new Date(value[0]).toLocaleString();
            const formattedEndDate = new Date(value[1]).toLocaleString();

            if (formattedStartDate && formattedEndDate) {
              setStartDate(moment(formattedStartDate).format("YYYY-MM-DD"));
              setEndDate(moment(formattedEndDate).format("YYYY-MM-DD"));
            }
          } else {
            setStartDate("");
            setEndDate("");
          }
        } else {
        }
        confirm();
      }, 3000),
    [fetchData, currentPage],
  );

  useEffect(() => {
    fetchData(currentPage, cardName, docNum, slpName, startDate, endDate);
  }, [fetchData, currentPage, cardName, docNum, slpName, startDate, endDate]);

  const handleNextPage = () => {
    if (hasMoreData) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setIsModalVisible(true);
  };

  const handleCreateProductClick = () => {
    setIsCreateProductModalVisible(true);
    console.log(total);
  };

  const closeCreateProductModal = () => {
    setIsCreateProductModalVisible(false);
    fetchData(currentPage, cardName, docNum, slpName, startDate, endDate);
  };

  return (
    <div className="flex h-full w-full overflow-y-auto">
      <Menubar />
      <div className="h-screen w-full overflow-y-auto">
        <Header
          title={"MySales"}
          currentPage={currentPage}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          hasMoreData={hasMoreData}
          onBtnClick={handleCreateProductClick}
          columns={columns}
          fdata={fdata}
          loading={loading}
          handleRowClick={handleRowClick}
          onStartDateChange={handleStartDate}
          onEndDateChange={handleEndDate}
          startDate={startDate}
          endDate={endDate}
          formattedDate={formattedDate}
          total={total}
        />
        <RowDataModal
          visible={isModalVisible}
          data={selectedRowData}
          onClose={() => setIsModalVisible(false)}
        />
        <CreateProductModal
          visible={isCreateProductModalVisible}
          onClose={closeCreateProductModal}
        />
      </div>
    </div>
  );
};

export default MySales;
